import React from 'react';
import { Grid } from '@material-ui/core';

import { RecipeFields } from 'config/recipes';

import validateRecipe from 'domain/recipe/usecases/validate_recipe';

import Description from 'components/typography/Description';
import RecipesMenuField from './RecipesMenuField';

import IngredientCard from 'components/recipes/steps/ingredients/ingredients_card/IngredientsCard';

import DirectionCard from 'components/recipes/steps/directions/direction_card/DirectionCard';

import DescriptionInput from 'components/recipes/steps/additional_data/description/DescriptionInput';
import ServingsInput from 'components/recipes/steps/additional_data/servings/ServingsInput';
import NutricionalDataInput from 'components/recipes/steps/additional_data/nutricional_data/NutricionalDataInput';
import CoverPhotoInput from '../steps/additional_data/cover_photo/CoverPhotoInput';

const RecipesMenu = ({ recipe, router }) => {
  const errors = validateRecipe(recipe) || {};

  const _extractField = (key) => {
    if (!errors) return null;
    return errors[key];
  };

  const additionalDataErrors = errors.additionalData || {};

  return (
    <Grid container direction="column" spacing={4}>
      <Grid item>
        <RecipesMenuField
          errorMessage={_extractField('title')}
          fieldTitle="Title"
          editRoute={router(RecipeFields.title)}
        >
          {recipe.title && <Description>{recipe.title}</Description>}
        </RecipesMenuField>
      </Grid>

      <Grid item>
        <RecipesMenuField
          errorMessage={_extractField('ingredients')}
          fieldTitle="Ingredients"
          editRoute={router(RecipeFields.ingredients)}
        >
          {recipe.ingredients.length > 0 &&
            recipe.ingredients.map((ingredient) => (
              <div style={{ marginBottom: 16 }} key={ingredient.id}>
                <IngredientCard
                  ingredientUIModel={ingredient}
                  showButtons={false}
                ></IngredientCard>
              </div>
            ))}
        </RecipesMenuField>
      </Grid>

      <Grid item>
        <RecipesMenuField
          errorMessage={_extractField('timeToPrepare')}
          fieldTitle="Time to prepare"
          editRoute={router(RecipeFields.timeToPrepare)}
        >
          {recipe.timeToPrepare && (
            <Description>
              {recipe.timeToPrepare} <b>minutes</b>
            </Description>
          )}
        </RecipesMenuField>
      </Grid>

      <Grid item>
        <RecipesMenuField
          errorMessage={_extractField('directions')}
          fieldTitle="Directions"
          editRoute={router(RecipeFields.directions)}
        >
          {recipe.directions.length > 0 &&
            recipe.directions.map((direction, index) => (
              <div key={direction.id} style={{ marginBottom: 16 }}>
                <DirectionCard
                  directionUIModel={direction}
                  index={index}
                ></DirectionCard>
              </div>
            ))}
        </RecipesMenuField>
      </Grid>

      <Grid item container>
        <RecipesMenuField
          errorMessage={_extractField('additionalData')}
          fieldTitle="Additional Data"
          editRoute={router(RecipeFields.additionalData)}
        >
          <Grid container direction="column" spacing={4}>
            <Grid item>
              <CoverPhotoInput
                coverPhoto={recipe.additionalData.coverPhotoURL}
                readOnly={true}
              ></CoverPhotoInput>
            </Grid>

            <Grid item>
              <DescriptionInput
                description={recipe.additionalData.description}
                readOnly={true}
                errorMessage={additionalDataErrors.description}
              ></DescriptionInput>
            </Grid>

            <Grid item>
              <ServingsInput
                servings={recipe.additionalData.servings}
                readOnly={true}
                errorMessage={additionalDataErrors.servings}
              ></ServingsInput>
            </Grid>

            <Grid item style={{ marginBottom: 16 }}>
              <NutricionalDataInput
                nutricionalData={recipe.additionalData.nutricionalData}
                errorMessages={additionalDataErrors.nutricionalData}
                readOnly={true}
              ></NutricionalDataInput>
            </Grid>
          </Grid>
        </RecipesMenuField>
      </Grid>
    </Grid>
  );
};

export default RecipesMenu;
